import React, { useState } from "react";
import axios from "axios";
import { MyApiUrl } from "./services";

const AllPlans = () => {
  const [JobData, setJobData] = useState([]);

  const UserID = localStorage.getItem("UserID");

  const GetAllJobs = async () => {
    await axios({
      method: "GET",
      url: MyApiUrl + "GetAllJobsForUser/" + UserID + "",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        setJobData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const SendRequest = async (job_pkid) => {
    await axios({
      method: "GET",
      url: MyApiUrl + "SendJobRequest/" + UserID + "/" + job_pkid + "",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        if (response.data) {
          alert(
            "Job request sent successfully, please wait for admin approval"
          );
          GetAllJobs();
        } else {
          alert("Failed..!");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  React.useEffect(() => {
    GetAllJobs();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content bg-white" style={{ marginTop: "2em" }}>
        <div className="content-inner section-wrapper1 overflow-hidden">
          <div className="container">
            <div className="section-head text-center">
              <h5
                className="sub-title wow fadeInUp"
                data-wow-delay="0.2s"
                style={{ fontSize: "20px", paddingBottom: "5%" }}
              >
                All Jobs
              </h5>
              <h2 className="title wow fadeInUp" data-wow-delay="0.4s">
                Please Find The Below All Jobs / Plans
              </h2>
            </div>
            <div className="dz-tabs style-1 wow fadeInUp" data-wow-delay="0.6s">
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button
                  className="nav-link active"
                  id="nav-category-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-category"
                  type="button"
                  role="tab"
                  aria-controls="nav-category"
                  aria-selected="true"
                >
                  All Jobs
                </button>
                {/* <button
                  className="nav-link"
                  id="nav-flow-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-flow"
                  type="button"
                  role="tab"
                  aria-controls="nav-flow"
                  aria-selected="false"
                >
                  HR
                </button>
                <button
                  className="nav-link"
                  id="nav-kundalini-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-kundalini"
                  type="button"
                  role="tab"
                  aria-controls="nav-kundalini"
                  aria-selected="false"
                >
                  Sandlewood
                </button>
                <button
                  className="nav-link"
                  id="nav-hatha-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-hatha"
                  type="button"
                  role="tab"
                  aria-controls="nav-hatha"
                  aria-selected="false"
                >
                  Rent-Out
                </button>
                <button
                  className="nav-link"
                  id="nav-vinyasa-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-vinyasa"
                  type="button"
                  role="tab"
                  aria-controls="nav-vinyasa"
                  aria-selected="false"
                >
                  All Jobs
                </button> */}
              </div>
            </div>
            <div
              className="tab-content wow fadeInUp"
              data-wow-delay="0.8s"
              id="nav-tabContent"
            >
              <div
                className="tab-pane fade show active"
                id="nav-category"
                role="tabpanel"
                aria-labelledby="nav-category-tab"
                tabindex="0"
              >
                <div className="row">
                  {JobData.map((item) => {
                    return (
                      <div className="col-md-6">
                        <div className="card">
                          <div
                            className="card-header"
                            style={{
                              background: "#3b6ff5",
                              color: "#fff",
                              fontWeight: 900,
                            }}
                          >
                            {item.job_name}
                          </div>
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-6">
                                <img
                                  alt="new"
                                  src="assets/images/about/asso.png"
                                />
                              </div>
                              <div className="col-md-6">
                                <table className="table">
                                  <tr>
                                    <td>Course Charge:</td>
                                    <td>{item.job_price}</td>
                                  </tr>
                                  <tr>
                                    <td>Daily Earning:</td>
                                    <td>{item.job_daily_earning}</td>
                                  </tr>
                                  <tr>
                                    <td>No Of Task Per Day:</td>
                                    <td>{item.job_per_day_task}</td>
                                  </tr>
                                  <tr>
                                    <td>Earning Per Task:</td>
                                    <td>{item.job_price_per_task}</td>
                                  </tr>
                                  <tr>
                                    <td
                                      colSpan="2"
                                      style={{ textAlign: "center" }}
                                    >
                                      {item.RequestID === 0 &&
                                      item.RequestStatus === 0 ? (
                                        <button
                                          className="btn btn-primary"
                                          style={{
                                            margin: "0 auto",
                                            display: "block",
                                          }}
                                          onClick={() =>
                                            SendRequest(item.job_pkid)
                                          }
                                        >
                                          Activate Plan
                                        </button>
                                      ) : item.RequestStatus === 0 ? (
                                        <p
                                          style={{
                                            background: "#ffa536",
                                            color: "#1c1c1c",
                                            fontWeight: "700",
                                            border: "1px solid #9f9f9f",
                                            borderRadius: "5px",
                                          }}
                                        >
                                          Request Pending
                                        </p>
                                      ) : (
                                        <p
                                          style={{
                                            background: "#08cf33",
                                            color: "#1c1c1c",
                                            fontWeight: "700",
                                            border: "1px solid #9f9f9f",
                                            borderRadius: "5px",
                                          }}
                                        >
                                          Active Job
                                        </p>
                                      )}
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="nav-flow"
                role="tabpanel"
                aria-labelledby="nav-flow-tab"
                tabindex="0"
              >
                <div className="schedule-table table-responsive"></div>
              </div>
              <div
                className="tab-pane fade"
                id="nav-kundalini"
                role="tabpanel"
                aria-labelledby="nav-kundalini-tab"
                tabindex="0"
              >
                <div className="schedule-table table-responsive"></div>
              </div>
              <div
                className="tab-pane fade"
                id="nav-hatha"
                role="tabpanel"
                aria-labelledby="nav-hatha-tab"
                tabindex="0"
              >
                <div className="schedule-table table-responsive"></div>
              </div>
              <div
                className="tab-pane fade"
                id="nav-vinyasa"
                role="tabpanel"
                aria-labelledby="nav-vinyasa-tab"
                tabindex="0"
              >
                <div className="schedule-table table-responsive"></div>
              </div>
              <div
                className="tab-pane fade"
                id="nav-yoga"
                role="tabpanel"
                aria-labelledby="nav-yoga-tab"
                tabindex="0"
              >
                <div className="schedule-table table-responsive"></div>
              </div>
            </div>
          </div>
          <svg
            className="bg-image"
            viewbox="0 0 1919 379"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M73.3165 123.52C157.912 108.819 150.516 156.618 189.162 158.467C227.762 160.317 227.762 145.616 271.909 162.166C316.056 178.715 325.208 213.663 367.506 208.115C409.804 202.614 409.804 178.715 441.054 209.965C472.303 241.214 485.201 266.963 536.651 298.212C588.149 329.462 619.398 305.562 645.147 292.711C670.895 279.86 657.998 272.464 698.447 285.361C738.895 298.212 849.193 270.661 893.34 265.114C937.487 259.613 981.588 217.315 1010.99 202.614C1040.39 187.914 1101.09 230.212 1126.83 244.912C1152.58 259.613 1178.33 239.411 1209.58 230.212C1240.83 221.013 1273.93 222.862 1329.08 198.963C1384.23 175.063 1429.11 187.637 1472.57 176.958C1535.07 161.565 1551.15 180.425 1636.12 211.814C1679.34 227.808 1679.02 227.115 1698.62 206.313C1708.14 196.189 1719.7 210.612 1733.15 213.524C1751.64 217.5 1767.64 208.901 1806.23 192.352C1837.62 178.9 1894.94 148.251 1920 156.757V373.436H0.0465088V134.614C17.844 132.442 41.9283 129.021 73.3165 123.52Z"
              fill="var(--primary)"
            ></path>
            <path
              d="M747.309 336.865C747.309 336.865 760.53 330.532 761.084 321.009C755.815 321.518 746.292 331.04 746.292 331.04C746.292 331.04 751.053 318.328 742.039 310.932C740.975 318.883 744.443 330.624 744.443 330.624C744.443 330.624 742.177 327.111 736.769 325.493C737.971 329.422 740.513 333.537 747.309 336.865Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M1708.14 273.534C1708.14 273.534 1732.04 262.07 1732.96 244.873C1723.4 245.844 1706.2 263.04 1706.2 263.04C1706.2 263.04 1714.8 240.112 1698.57 226.752C1696.68 241.082 1702.92 262.301 1702.92 262.301C1702.92 262.301 1698.8 255.968 1689.05 253.055C1691.27 260.082 1695.84 267.524 1708.14 273.534Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M343.56 303.582C343.56 303.582 353.314 302.935 354.886 294.475C353.314 290.407 347.952 299.191 347.952 299.191C347.952 299.191 346.057 284.121 337.597 278.435C342.312 291.332 345.456 299.191 345.456 299.191C345.456 299.191 338.522 289.113 330.386 288.512C332.882 296.648 343.56 303.582 343.56 303.582Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M1438.27 246.676C1438.27 246.676 1448.02 246.029 1449.59 237.57C1448.02 233.502 1442.66 242.285 1442.66 242.285C1442.66 242.285 1440.76 227.215 1432.3 221.529C1437.02 234.426 1440.16 242.285 1440.16 242.285C1440.16 242.285 1433.23 232.207 1425.09 231.606C1427.59 239.742 1438.27 246.676 1438.27 246.676Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M102.624 254.257L116.539 238.263C111.407 237.246 101.607 249.08 101.607 249.08C101.607 249.08 105.722 237.754 94.9044 223.84C91.2525 237.246 102.624 254.257 102.624 254.257Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M234.557 199.849V286.201"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M259.982 204.471C259.982 217.507 255.128 223.193 235.62 222.315"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M208.716 222.547C208.716 235.583 213.57 241.269 233.078 240.391"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M1025.74 221.899V308.251"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M1051.16 226.521C1051.16 239.558 1046.31 245.243 1026.8 244.365"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M999.894 244.597C999.894 257.633 1004.75 263.319 1024.26 262.441"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M1848.26 175.394V261.746"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M1873.68 180.017C1873.68 193.053 1868.83 198.739 1849.32 197.86"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M1822.41 198.092C1822.41 211.128 1827.27 216.814 1846.78 215.936"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M111.593 249.312C144.09 234.01 144.09 232.115 174.646 258.881C205.203 285.646 235.759 283.705 235.759 283.705C235.759 283.705 298.813 274.136 348.461 302.796C398.109 331.457 407.678 350.549 476.464 354.386C545.25 358.223 741.993 329.562 787.85 329.562C833.707 329.562 803.151 348.654 854.695 327.667C906.284 306.633 885.251 302.843 975.07 299.006C1064.84 295.169 1196.68 277.972 1311.28 264.613C1425.92 251.253 1450.93 227.354 1607.74 253.657C1664.46 263.18 1732.64 268.773 1799.86 255.876C1834.48 249.219 1875.07 252.501 1919.95 263.087V378.344H0V187.229C41.8356 191.666 83.2553 262.671 111.593 249.312Z"
              fill="var(--dark)"
            ></path>
          </svg>
          <div className="circle1 style-2 dz-parallax"></div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AllPlans;
